module.exports = __webpack_public_path__ + "static/media/cefta.e0e7f32f.svg";